import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CallBreakdown, CallBreakdownDetails } from 'src/app/model/call/call.model';
import { IncidentsService } from 'src/app/services/http/incidents/incidents.service';

@Component({
  selector: 'app-breakdown-stats',
  templateUrl: './breakdown-stats.component.html',
  styleUrls: ['./breakdown-stats.component.scss']
})
export class BreakdownStatsComponent implements OnInit {

  /**
   * Boolean indicating if spinner has to be shown while something is being loaded
   */
   public isLoading : boolean = false;
  
   /**
   * Search From
   */
  searchForm!: FormGroup;

  stats!: CallBreakdown[];

  details!: any[];
  constructor(private service : IncidentsService,
              private builder: FormBuilder ) { }

  ngOnInit(): void {
   
    this.searchForm = this.builder.group({
      startDate: ['', Validators.required],
      endDate: ['', Validators.required]
    });
  }

  onSubmit(){
    
    this.isLoading = true;

    this.service.getPannesStats( this.searchForm.controls.startDate.value, 
                                this.searchForm.controls.endDate.value )
                .subscribe( (stats) => {
                    console.log(stats);
                    
                    this.stats = stats;
                    this.isLoading = false;
                });

    this.service.getPannesStatsDetails( this.searchForm.controls.startDate.value, 
                  this.searchForm.controls.endDate.value )
    .subscribe( (details) => {
      console.log(details);
      this.details = details;
     // this.isLoading = false;
  });
                
  }

  public getTotal() : string{
    let total = 0;
    for ( let i = 0; i < this.stats.length; i++){
      total += this.stats[i].NB;
    }
    return total.toString();
  }
}
